var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('NcContent',{attrs:{"app-name":"files"}},[_c('Navigation'),_vm._v(" "),_c('FilesList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }